import React from "react";
import { useTranslation } from "react-i18next";
import { Loader2, ArrowUpRight } from "lucide-react";

const USER_ROLES = new Set(["human", "user"]);

export default function ChatHistoryRowPreview({ messages, isLoading, onOpen }) {
    const { t } = useTranslation();

    return (
        <div className="px-3 pb-3 pt-2 bg-gray-50 border-t border-gray-100">
            {isLoading || messages === null ? (
                <div className="flex items-center gap-2 text-xs text-gray-500 py-3">
                    <Loader2 className="w-3.5 h-3.5 animate-spin" />
                    {t("chatTwoColumnPage.loadingPreview")}
                </div>
            ) : messages.length === 0 ? (
                <p className="text-xs text-gray-500 py-3">
                    {t("chatTwoColumnPage.noMessagesYet")}
                </p>
            ) : (
                <ul className="flex flex-col gap-2 py-1">
                    {messages.map((m) => {
                        const isUser = USER_ROLES.has(m.role);
                        return (
                            <li
                                key={m.id}
                                className={`flex ${
                                    isUser ? "justify-end" : "justify-start"
                                }`}
                            >
                                <div
                                    className={`max-w-[85%] rounded-2xl px-3 py-2 text-sm leading-relaxed whitespace-pre-wrap break-words ${
                                        isUser
                                            ? "bg-blue-600 text-white rounded-br-sm"
                                            : "bg-white text-gray-800 border border-gray-200 rounded-bl-sm"
                                    }`}
                                >
                                    {m.content}
                                </div>
                            </li>
                        );
                    })}
                </ul>
            )}
            <button
                onClick={onOpen}
                className="mt-3 inline-flex items-center gap-1 text-xs font-medium text-blue-600 hover:text-blue-700"
            >
                {t("chatTwoColumnPage.openConversation")}
                <ArrowUpRight className="w-3.5 h-3.5" />
            </button>
        </div>
    );
}
